export var constants = {
    // Currently we do not use roundings, but the variables have been added for
    // Bootstrap compatibility
    borderRadius: {
        base: 0,
        large: 0,
        small: 0
    },
    navBarHeight: '40px',
    fontWeight: {
        light: 300,
        normal: 400,
        bold: 700
    },
    // Bootstrap 3 sets html font-size to 62.5% i.e. 10px with Browser's default size being 16px.
    // Bootstrap 4 uses different base font-size and hence these values need to be changed.
    fontSize: {
        h1: '3.6rem', // 36px
        h2: '3rem', // 30px
        h3: '2.4rem', // 24px
        h4: '1.8rem', // 18px

        large: '1.8rem',
        medium: '1.6rem',
        normal: '1.4rem', // default text
        small: '1.2rem'
    },
    classPrefix: 'oc-layout'
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../node_modules/@opuscapita/oc-cm-theme/lib/es/constants.js
// module id = null
// module chunks = 